import { render, staticRenderFns } from "./AddContractModal.vue?vue&type=template&id=97e23ae8&scoped=true&"
import script from "./AddContractModal.vue?vue&type=script&lang=js&"
export * from "./AddContractModal.vue?vue&type=script&lang=js&"
import style0 from "./AddContractModal.vue?vue&type=style&index=0&id=97e23ae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e23ae8",
  null
  
)

export default component.exports